import { Navigate, RouteObject } from "react-router";
import { RequirementsIndexRoute } from "@/routes/processes/[processId]/qpm/requirements/_components/requirements-index-route";
import { AdditionalInfoRoute } from "@/routes/processes/[processId]/qpm/requirements/[requirementId]/additional-info/additional-info-route";
import { TotalOverviewRoute } from "@/routes/processes/[processId]/qpm/requirements/[requirementId]/total-overview/total-overview-route";
import { AssessmentRoute } from "@/routes/processes/[processId]/qpm/requirements/[requirementId]/assessment/assessment-route";
import { InfoRoute } from "@/routes/processes/[processId]/qpm/requirements/[requirementId]/info/info-route";
import { RequirementRouteNav } from "@/routes/processes/[processId]/qpm/_components/nav-links/requirement-nav";
import RequirementLayout from "@/routes/processes/[processId]/qpm/requirements/[requirementId]/requirement-layout";

export const requirementRoutes: RouteObject[] = [
  {
    index: true,
    element: <RequirementsIndexRoute />,
  },
  {
    path: ":requirementId",
    element: <RequirementLayout />,
    children: [
      {
        index: true,
        element: <Navigate to={RequirementRouteNav.Assessment} replace />,
      },
      {
        path: RequirementRouteNav.Info,
        element: <InfoRoute />,
      },
      {
        path: RequirementRouteNav.Assessment,
        element: <AssessmentRoute />,
      },
      {
        path: RequirementRouteNav.AdditionalInfo,
        element: <AdditionalInfoRoute />,
      },
      {
        path: RequirementRouteNav.TotalOverview,
        element: <TotalOverviewRoute />,
      },
    ],
  },
];
